import { render } from "./deviceManage.vue?vue&type=template&id=a32b06c8&scoped=true"
import script from "./deviceManage.vue?vue&type=script&lang=js"
export * from "./deviceManage.vue?vue&type=script&lang=js"

import "./deviceManage.vue?vue&type=style&index=0&id=a32b06c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32b06c8"]])

export default __exports__